import { httpClient } from '../http/httpClient'

export async function userEnable(id: string) {
  const { data } = await httpClient.patch(`/user/${id}/enable`)

  return data
}
